import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  useLegalClientHeadSavePersonalDataMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientCreateHeadSaveParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

import { parseLegalClientHeadEntity } from './helpers';

export const useLegalClientHeadSavePersonalData = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientHeadSavePersonalDataMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    data: data?.legalClientHeadSavePersonalData
      ? parseLegalClientHeadEntity(data.legalClientHeadSavePersonalData)
      : undefined,
    loading,
    error,
    savePersonalData: useCallback(
      async (
        id: string,
        headId: string,
        param: LegalClientCreateHeadSaveParam
      ) => {
        const res = await handle({
          variables: {
            id,
            headId,
            input: {
              dateOfBirth: formatToISODate(param.dateOfBirth),
              email: param.email,
              firstName: param.firstName,
              lastName: param.lastName,
              middleName: param.middleName,
            },
          },
        });
        return res?.data?.legalClientHeadSavePersonalData
          ? parseLegalClientHeadEntity(res.data.legalClientHeadSavePersonalData)
          : undefined;
      },
      [handle]
    ),
  };
};
